import { useLocation } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Table } from "react-bootstrap";
import { formatSalesValue } from "../../utils/formatUtils";

const EmployeeDetails = () => {
    const location = useLocation();
    const { startdate, enddate, employee_name, outlet_name } = location.state || {};
    const token = localStorage.getItem('token');
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [employeeData, setEmployeeData] = useState([]);
    const [aggregatedItems, setAggregatedItems] = useState({ Beverage: [], Food: [], Other: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchEmployeeDetails = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${baseUrl}/employee-orders`, {
                    startDate: startdate,
                    endDate: enddate,
                    employee: employee_name,
                    outlet: outlet_name,
                    token: token
                });

                const data = response.data?.orders || [];
                const items = response.data?.aggregated_items || { Beverage: [], Food: [], Other: [] };
                setEmployeeData(data);
                setAggregatedItems(items);
            } catch (err) {
                setError(err.response?.data?.error || "Failed to fetch data");
            } finally {
                setLoading(false);
            }
        };

        fetchEmployeeDetails();
    }, []);

    const handleShowModal = (order) => {
        setSelectedOrder(order);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedOrder(null);
    };

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow">
                <div className="max-w-6xl p-2 my-4 mx-auto">
                    <h2 className="text-lg font-semibold mb-2">
                        Employee Details: {employee_name} ({outlet_name}) - {new Date(startdate).toLocaleDateString()} to {new Date(enddate).toLocaleDateString()}
                    </h2>

                    <div className="rounded-md border overflow-x-auto max-h-[600px]">
                        <table className="text-center text-sm min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50 sticky top-0">
                                <tr>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Date</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Bill No.</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Guests</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Sub Total</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total VAT</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Sales</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Discount</th>
                                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Payment Mode</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {employeeData.length > 0 ? (
                                    employeeData.map((employee, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {new Date(employee.Date).toLocaleDateString()}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900 hover:underline">
                                                <div className='hover:cursor-pointer' onClick={() => handleShowModal(employee)}>
                                                    {employee.bill_no}
                                                </div>
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {employee.NoOfGuests}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {formatSalesValue(Number(employee.Total) - Number(employee.VAT))}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {formatSalesValue(employee.VAT)}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
                                                {formatSalesValue(employee.Total)}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {formatSalesValue(employee.DiscountAmt)}
                                            </td>
                                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                                {employee.PaymentMode}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="px-4 py-6 text-center text-sm text-gray-700">
                                            {loading ? "Loading data..." : error || "No employee data available"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <h3 className="text-xl mt-5">Items Sold</h3>

                    <div className='flex gap-20'>
                        <div className="w-1/2">
                            <div className="rounded-md border overflow-x-auto max-h-[500px]">
                                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                                    <thead className="bg-gray-100 sticky top-0">
                                        <tr>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Group</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Food Items</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Quantity</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                        {aggregatedItems.Food.length > 0 ? (
                                            <>
                                                {aggregatedItems.Food
                                                    .sort((a, b) => b.TotalQuantity - a.TotalQuantity)
                                                    .map((item, index) => (
                                                        <tr key={`food-${index}`} className="hover:bg-gray-50">
                                                            <td className="px-3 py-2">{item.Group}</td>
                                                            <td className="px-3 py-2">{item.ItemName}</td>
                                                            <td className="px-3 py-2">{item.TotalQuantity}</td>
                                                            <td className="px-3 py-2">{formatSalesValue(item.TotalAmount)}</td>
                                                        </tr>
                                                    ))}
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={4} className="px-3 py-4 text-gray-700">No food data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-2 p-2 space-y-1">
                                {(() => {
                                    const totalFoodItems = aggregatedItems.Food.length || 0;
                                    const totalCount = aggregatedItems.Food.reduce((sum, item) => sum + item.TotalQuantity, 0)
                                    const totalAmount = formatSalesValue(aggregatedItems.Food.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0))
                                    return (
                                        <div className='grid grid-cols-2 gap-2'>
                                            <label className="mr-2">Total Item Count :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalFoodItems}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />

                                            <label className="mr-2">Total Items Sold :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalCount}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />

                                            <label className="mr-2">Total Amount :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalAmount}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>

                        <div className="w-1/2">
                            <div className="rounded-md border overflow-x-auto max-h-[500px]">
                                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center mb-6">
                                    <thead className="bg-gray-100 sticky top-0">
                                        <tr>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Group</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Beverage Items</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Quantity</th>
                                            <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                        {aggregatedItems.Beverage.length > 0 ? (
                                            <>
                                                {aggregatedItems.Beverage
                                                    .sort((a, b) => b.TotalQuantity - a.TotalQuantity)
                                                    .map((item, index) => (
                                                        <tr key={`beverage-${index}`} className="hover:bg-gray-50">
                                                            <td className="px-3 py-2">{item.Group}</td>
                                                            <td className="px-3 py-2">{item.ItemName}</td>
                                                            <td className="px-3 py-2">{item.TotalQuantity}</td>
                                                            <td className="px-3 py-2">{formatSalesValue(item.TotalAmount)}</td>
                                                        </tr>
                                                    ))}
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={4} className="px-3 py-4 text-gray-700">No beverage data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-2 p-2 space-y-1">
                                {(() => {
                                    const totalBeverageItems = aggregatedItems.Beverage.length || 0;
                                    const totalCount = aggregatedItems.Beverage.reduce((sum, item) => sum + item.TotalQuantity, 0)
                                    const totalAmount = formatSalesValue(aggregatedItems.Beverage.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0))
                                    return (
                                        <div className='grid grid-cols-2 gap-2'>
                                            <label className="mr-2">Total Item Count :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalBeverageItems}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />

                                            <label className="mr-2">Total Items Sold :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalCount}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />

                                            <label className="mr-2">Total Amount :</label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={totalAmount}
                                                className="border p-1 rounded w-full font-semibold text-center"
                                            />
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>

                    </div>

                    <Modal show={showModal} onHide={handleCloseModal} size="md">
                        <Modal.Header closeButton>
                            <Modal.Title className="w-100 text-center">Invoice</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedOrder && (
                                <>
                                    <div className="space-y-2 mb-4">
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Bill No:</span>
                                            <span>{selectedOrder.bill_no}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Date:</span>
                                            <span>{new Date(selectedOrder.Date).toLocaleDateString()}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Start Time:</span>
                                            <span>{selectedOrder.Start_Time}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="font-semibold">End Time:</span>
                                            <span>{selectedOrder.End_Time}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Type:</span>
                                            <span>{selectedOrder.Type}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Table No:</span>
                                            <span>{selectedOrder.Table_No || "-"}</span>
                                        </div>
                                        {selectedOrder.NoOfGuests > 0 && (
                                            <div className="flex justify-between">
                                                <span className="font-semibold">No. of Guests:</span>
                                                <span>{selectedOrder.NoOfGuests}</span>
                                            </div>
                                        )}
                                        <div className="flex justify-between">
                                            <span className="font-semibold">Payment Mode:</span>
                                            <span>{selectedOrder.PaymentMode}</span>
                                        </div>
                                    </div>

                                    <Table striped bordered hover responsive className="text-sm">
                                        <thead>
                                            <tr>
                                                <th>Item Name</th>
                                                <th>Rate</th>
                                                <th>Qty</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrder.details.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.ItemName}</td>
                                                    <td>{formatSalesValue(item.itemRate)}</td>
                                                    <td>{item.count}</td>
                                                    <td>{formatSalesValue(item.Total)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                    <div className="text-right mt-4">
                                        <p>Sub Total: {formatSalesValue(Number(selectedOrder.Total) - Number(selectedOrder.VAT))}</p>
                                        <p>VAT: {formatSalesValue(selectedOrder.VAT)}</p>
                                        <p className="font-bold">Total: {formatSalesValue(selectedOrder.Total)}</p>
                                        <p className="font-bold">(After Discount)</p>
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary" onClick={handleCloseModal}>
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default EmployeeDetails;